import { render, staticRenderFns } from "./TourParachute.vue?vue&type=template&id=28b6a614&"
import script from "./TourParachute.vue?vue&type=script&lang=js&"
export * from "./TourParachute.vue?vue&type=script&lang=js&"
import style0 from "./TourParachute.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports